import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { MachineDoc } from '@models';

export type DocStatus = 'idle' | 'loading' | 'loaded' | 'saving' | 'error';

export interface DocsState {
  entities: EntityState<MachineDoc>;
  /** `${projectId}::${key}` -> docId */
  keyIndex: Record<string, string>;
  /** `${projectId}::${key}` -> status */
  statusByKey: Record<string, DocStatus>;
  /** `${projectId}::${key}` -> last error */
  errorByKey: Record<string, string | null>;
}

export const docsAdapter = createEntityAdapter<MachineDoc>({ selectId: (d) => d.id ?? '' });

export const initialDocsState: DocsState = {
  entities: docsAdapter.getInitialState(),
  keyIndex: {},
  statusByKey: {},
  errorByKey: {},
};
